import type { ISpread } from "../../spreadsSlice";

export const crossChoiceSpread: ISpread = {
  id: "spread_cross_choice",
  name: "Крест выбора",
  altNames: ["Cross Spread"],
  purpose:
    "Рассмотрение двух сторон ситуации, анализ выбора между альтернативами и выявление скрытых факторов.",
  cardsCount: 4,
  layout: `  [2]
[3][1][4]`,
  positions: [
    {
      id: "situation",
      title: "Суть вопроса",
      meaning: "Основная тема или энергия ситуации.",
    },
    {
      id: "higher_influence",
      title: "Внешнее влияние / высшее руководство",
      meaning:
        "То, что находится над ситуацией и может пока не осознаваться.",
    },
    {
      id: "option_a",
      title: "Первая возможность",
      meaning: "Первое возможное направление или аспект ситуации.",
    },
    {
      id: "option_b",
      title: "Вторая возможность",
      meaning: "Второе возможное направление или аспект ситуации.",
    },
  ],
  symbolism:
    "Вертикаль показывает связь материального и духовного, горизонталь раскрывает альтернативы, а центр является точкой пересечения и выбора.",
  archetypes: ["Крест", "Равновесие", "Точка выбора"],
  psychology:
    "Помогает увидеть внутренние и внешние влияния, сопоставить противоположности и осознать внутреннюю динамику, стоящую за выбором.",
  procedure: {
    preparation:
      "Сформулировать чёткий вопрос, связанный с выбором между альтернативами.",
    steps:
      "Перетасовать карты; выложить сначала центр, затем верхнюю карту, после этого левую и правую альтернативы; прочитать суть, влияние и обе возможности, затем сопоставить их.",
  },
  interpretations: [
    "2 Мечей в центре может показывать тупик или невозможность сделать выбор.",
    "Жрица во второй позиции может указывать на интуицию или скрытую информацию.",
    "Солнце и Луна в двух альтернативах могут показывать контраст ясности и неопределённости.",
  ],
  nuances: [
    "Не торопиться с выводами: первая реакция на альтернативы может быть поверхностной.",
    "Внешнее влияние не обязательно является положительным и может также ограничивать.",
    "Если различие между альтернативами неочевидно, решение можно отложить.",
  ],
  examples: [
    {
      cards: ["2 Мечей", "Жрица", "Солнце", "Луна"],
      interpretation:
        "Ситуация выбора находится в тупике; скрытая информация или интуитивное понимание становятся важным фактором, а два направления различаются степенью ясности и неопределённости.",
    },
  ],
  selfQuestions: [
    "Какие энергии скрываются за выбором?",
    "Чего я избегаю, стараясь не принимать решение?",
    "Что меня удерживает в текущей точке?",
  ],
};

